const phoneMasks: Record<string, string> = {
  '+1': '(000) 000-0000', // EUA, Canadá
  '+7': '000 000-00-00', // Rússia, Cazaquistão
  '+20': '0000 000 000', // Egito
  '+27': '000 000 0000', // África do Sul
  '+30': '0000 000 000', // Grécia
  '+31': '00 000 0000', // Holanda (Países Baixos)
  '+32': '000 00 00 00', // Bélgica
  '+33': '00 00 00 00 00', // França
  '+34': '000 00 00 00', // Espanha
  '+351': '000 000 000', // Portugal
  '+36': '00 000 0000', // Hungria
  '+39': '000 000 0000', // Itália
  '+40': '000 000 000', // Romênia
  '+41': '00 000 00 00', // Suíça
  '+43': '0000 000000', // Áustria
  '+44': '0000 000000', // Reino Unido
  '+45': '00 00 00 00', // Dinamarca
  '+46': '000-000 00 00', // Suécia
  '+47': '000 00 000', // Noruega
  '+48': '000 000 000', // Polônia
  '+49': '0000 0000000', // Alemanha
  '+51': '000 000 000', // Peru
  '+52': '000 000 0000', // México
  '+53': '000 000 0000', // Cuba
  '+54': '00 0000-0000', // Argentina
  '+55': '(00) 00000-0000', // Brasil
  '+56': '0 0000 0000', // Chile
  '+57': '000 000 0000', // Colômbia
  '+58': '0000-0000000', // Venezuela
  '+60': '00-000 0000', // Malásia
  '+61': '0000 000 000', // Austrália
  '+62': '000-0000-0000', // Indonésia
  '+63': '0000 000 0000', // Filipinas
  '+64': '00 000 0000', // Nova Zelândia
  '+65': '0000 0000', // Singapura
  '+66': '00 000 0000', // Tailândia
  '+81': '00-0000-0000', // Japão
  '+82': '000-0000-0000', // Coreia do Sul
  '+84': '000 000 0000', // Vietnã
  '+86': '000-0000-0000', // China
  '+90': '000 000 00 00', // Turquia
  '+91': '00000 00000', // Índia
  '+92': '0000-0000000', // Paquistão
  '+93': '00 000 0000', // Afeganistão
  '+94': '00 000 0000', // Sri Lanka
  '+95': '00 000 000', // Myanmar
  '+98': '000 000 0000', // Irã
  '+212': '0000-000000', // Marrocos
  '+213': '000 00 00 00', // Argélia
  '+216': '00 000 000', // Tunísia
  '+218': '000-0000000', // Líbia
  '+220': '000 0000', // Gâmbia
  '+221': '000 000 000', // Senegal
  '+222': '00 00 00 00', // Mauritânia
  '+223': '00 00 00 00', // Mali
  '+224': '000 000 000', // Guiné
  '+225': '00 00 00 00', // Costa do Marfim
  '+226': '00 00 00 00', // Burkina Faso
  '+227': '00 00 00 00', // Níger
  '+228': '00 00 00 00', // Togo
  '+229': '00 00 00 00', // Benin
  '+230': '000 0000', // Maurício
  '+231': '000 000 0000', // Libéria
  '+232': '000 000000', // Serra Leoa
  '+233': '000 000 0000', // Gana
  '+234': '000 000 0000', // Nigéria
  '+235': '00 00 00 00', // Chade
  '+236': '00 00 00 00', // República Centro-Africana
  '+237': '0000 0000', // Camarões
  '+238': '000 00 00', // Cabo Verde
  '+239': '000 0000', // São Tomé e Príncipe
  '+240': '000 000 000', // Guiné Equatorial
  '+241': '00 00 00 00', // Gabão
  '+242': '00 000 0000', // Congo
  '+243': '000 000 000', // República Democrática do Congo
  '+244': '000 000 000', // Angola
  '+245': '000 000 000', // Guiné-Bissau
  '+246': '000 0000', // Território Britânico do Oceano Índico
  '+248': '0 000 000', // Seychelles
  '+249': '00 000 0000', // Sudão
  '+250': '0000 000 000', // Ruanda
  '+251': '00 000 0000', // Etiópia
  '+252': '00 000 000', // Somália
  '+253': '00 00 00 00', // Djibouti
  '+254': '000 000 000', // Quênia
  '+255': '00 000 0000', // Tanzânia
  '+256': '000 000 000', // Uganda
  '+257': '00 00 00 00', // Burundi
  '+258': '00 000 0000', // Moçambique
  '+260': '000 000 000', // Zâmbia
  '+261': '00 00 000 00', // Madagascar
  '+262': '000 00 00 00', // Reunião
  '+263': '000 000 0000', // Zimbábue
  '+264': '000 000 0000', // Namíbia
  '+265': '000 000 000', // Malaui
  '+266': '0000 0000', // Lesoto
  '+267': '00 000 000', // Botsuana
  '+268': '00 00 00 00', // Essuatíni (Suazilândia)
  '+269': '00 00 0000', // Comores
  '+290': '0000', // Santa Helena
  '+291': '00 000 000', // Eritreia
  '+297': '000 0000', // Aruba
  '+298': '000000', // Ilhas Faroé
  '+299': '00 00 00', // Groenlândia
  '+372': '0000 0000', // Estônia
  '+373': '0000 0000', // Moldávia
  '+374': '00 000 000', // Armênia
  '+375': '00 000 0000', // Bielorrússia
  '+376': '000 000', // Andorra
  '+377': '00 00 00 00', // Mônaco
  '+378': '000 000 000', // San Marino
  '+380': '00 000 0000', // Ucrânia
  '+381': '00 000 000', // Sérvia
  '+382': '00 000 000', // Montenegro
  '+383': '00 000 000', // Kosovo
  '+385': '00 000 0000', // Croácia
  '+386': '000 000 000', // Eslovênia
  '+387': '00 000 000', // Bósnia e Herzegovina
  '+389': '00 000 000', // Macedônia do Norte
  '+420': '000 000 000', // República Tcheca
  '+421': '000 000 000', // Eslováquia
  '+423': '000 000 000', // Liechtenstein
  '+501': '000-0000', // Belize
  '+502': '0000 0000', // Guatemala
  '+503': '0000 0000', // El Salvador
  '+504': '0000-0000', // Honduras
  '+505': '0000 0000', // Nicarágua
  '+506': '0000 0000', // Costa Rica
  '+507': '0000-0000', // Panamá
  '+509': '00 00 0000', // Haiti
  '+670': '0000 000', // Timor-Leste
  '+672': '0000 000', // Ilha Norfolk
  '+673': '000 0000', // Brunei
  '+674': '000 0000', // Nauru
  '+675': '000 0000', // Papua Nova Guiné
  '+676': '00000', // Tonga
  '+677': '00000', // Ilhas Salomão
  '+678': '00000', // Vanuatu
  '+679': '000 0000', // Fiji
  '+680': '000 0000', // Palau
  '+681': '00 0000', // Wallis e Futuna
  '+682': '00 000', // Ilhas Cook
  '+683': '00000', // Niue
  '+685': '00 000', // Samoa
  '+686': '000 00000', // Kiribati
  '+687': '00 00 00', // Nova Caledônia
  '+688': '000000', // Tuvalu
  '+689': '00 00 00', // Polinésia Francesa
  '+690': '0000', // Ilhas Pitcairn
  '+691': '000-0000', // Estados Federados da Micronésia
  '+692': '000-0000', // Ilhas Marshall
  '+850': '00-000-0000', // Coreia do Norte
  '+852': '0000 0000', // Hong Kong
  '+853': '0000 0000', // Macau
  '+855': '00 000 000', // Camboja
  '+856': '00 000 000', // Laos
  '+880': '00000-000000', // Bangladesh
  '+886': '0000 000 000', // Taiwan
  '+960': '000-0000', // Maldivas
  '+961': '00 000 000', // Líbano
  '+962': '00 0000 0000', // Jordânia
  '+963': '00 0000 0000', // Síria
  '+964': '000 000 0000', // Iraque
  '+965': '0000 0000', // Kuwait
  '+966': '000 000 0000', // Arábia Saudita
  '+967': '000 000 000', // Iémen
  '+968': '0000 0000', // Omã
  '+970': '00 000 000', // Palestina
  '+971': '000 000 0000', // Emirados Árabes Unidos
  '+972': '00-000-0000', // Israel
  '+973': '0000 0000', // Bahrein
  '+974': '0000 0000', // Catar
  '+975': '00 000 000', // Butão
  '+976': '00 00 00 00', // Mongólia
  '+977': '000-0000000', // Nepal
  '+992': '00 000 0000', // Tajiquistão
  '+993': '00 00 00 00', // Turcomenistão
  '+994': '00 000 00 00', // Azerbaijão
  '+995': '000 000 000', // Geórgia
  '+996': '000 000 000', // Quirguistão
  '+998': '00 000 0000', // Uzbequistão
};

export default phoneMasks;
